import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import App from './App';
import Checkout from './pages/Checkout';
import AdminPanel from './pages/AdminPanel';
import AdminLogin from './pages/AdminLogin';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/checkout/:packageId" element={<Checkout />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/paypal/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/paypal/cancel" element={<CheckoutCancel />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  </React.StrictMode>,
);

function CheckoutSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 flex items-center justify-center">
      <div className="text-center text-white">
        <div className="text-6xl mb-4">✅</div>
        <h1 className="text-4xl font-bold mb-2">Zahlung erfolgreich!</h1>
        <p className="text-xl text-slate-300 mb-6">Dein Paket ist jetzt aktiv.</p>
        <a href="http://localhost:4001" className="bg-green-600 hover:bg-green-700 px-8 py-3 rounded-lg transition">
          Zur App →
        </a>
      </div>
    </div>
  );
}

function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-red-900 to-slate-900 flex items-center justify-center">
      <div className="text-center text-white">
        <div className="text-6xl mb-4">❌</div>
        <h1 className="text-4xl font-bold mb-2">Zahlung abgebrochen</h1>
        <p className="text-xl text-slate-300 mb-6">Du kannst jederzeit erneut versuchen.</p>
        <a href="/" className="bg-purple-600 hover:bg-purple-700 px-8 py-3 rounded-lg transition">
          Zurück zur Startseite →
        </a>
      </div>
    </div>
  );
}
